import React, { useState, useEffect, useRef, useCallback } from 'react';

import { Form, Input, Button, Checkbox, Card, Space, message, Select, Tag, List, Avatar, Dropdown, AutoComplete, Modal } from 'antd';
import { SendOutlined, PlusOutlined, DeleteOutlined, SearchOutlined, UserOutlined, DownOutlined } from '@ant-design/icons';
import GroupChatSelector from '../components/GroupChatSelector';
import ValueReuseComponent from '../components/ValueReuseComponent';
import Editor from '../components/etitor';
import { API_BASE_URL,CHATDATA } from '../config';
import { useValueChoice } from '../stores/ValueChoice';
import { useStaffSearch } from '../stores/StaffSearch';
import { usePublishCard } from '../stores/PublishCard';
import SelectValueUsers from '../components/selectvalueusers';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

const { TextArea } = Input;

const PostEditor = ({ onSubmit, corpId, accessToken, userInfo, userOptions }) => {
  const [form] = Form.useForm();
  const [selectedChats, setSelectedChats] = useState(CHATDATA);

  
  // 使用员工搜索Hook
  const { menuProps, searchQuery, searchingUsers, selectedUsers, dropdownOpen, setSearchQuery, setSelectedUsers, handleInputClick, handleDropdownVisibleChange, handleSelectUserWithClose, handleSearchUsers, handleRemoveUser, resetSearchState } = useStaffSearch({ accessToken, apiBaseUrl: API_BASE_URL });
  
  // 使用发布卡片Hook
  const { submitting, handleFinish } = usePublishCard({ userInfo, onSubmit });

  // Value Drawer相关状态和函数
  const { valueDrawerVisible, selectedValues, valueGroups, handleValueCheckboxChange, handleValueDrawerClose, handleValueButtonClick, setValueDrawerVisible, setSelectedValues, getAllSelectedValues } = useValueChoice();

  const quillRef = useRef();
  const [editorData, setEditorData] = useState('');
  const [editorInitialized, setEditorInitialized] = useState(false);
  const [initialContent, setInitialContent] = useState('');

  // 保存草稿到本地存储
  const saveDraftToLocalStorage = () => {
    const formData = form.getFieldsValue();
    // 确保selectedUsers是有效的数组
    const usersToSave = Array.isArray(selectedUsers) ? selectedUsers : [];
    const draftData = {
      title: formData.title || '',
      selectedValuesall: formData.selectedValuesall || [],
      selectedUsers: JSON.parse(JSON.stringify(usersToSave)), // 深度复制selectedUsers
      content: editorData || formData.content || '', // 优先使用editorData
      selectedValues: selectedValues
    };
    console.log('保存草稿:', draftData); // 调试日志
    localStorage.setItem('postEditorDraft', JSON.stringify(draftData));
    // message.success('草稿已保存');
  };

  // 从本地存储加载草稿
  const loadDraftFromLocalStorage = () => {
    const savedDraft = localStorage.getItem('postEditorDraft');
    if (savedDraft) {
      const draftData = JSON.parse(savedDraft);
      console.log('加载草稿数据:', draftData); // 调试日志
      
      form.setFieldsValue({
        title: draftData.title,
        selectedValuesall: draftData.selectedValuesall,
        selectedUsers: draftData.selectedUsers,
        content: draftData.content
      });
      
      if (draftData.selectedValues) {
        setSelectedValues(draftData.selectedValues);
      }
      
      if (draftData.content) {
        setInitialContent(draftData.content);
        setEditorData(draftData.content);
      }
      
      // 恢复selectedUsers状态
      if (draftData.selectedUsers && Array.isArray(draftData.selectedUsers)) {
        console.log('恢复selectedUsers:', draftData.selectedUsers); // 调试日志
        setSelectedUsers(draftData.selectedUsers);
      }
      
      return draftData.content || '';
    }
    return '';
  };

  // 清除本地存储的草稿
  const clearDraftFromLocalStorage = () => {
    localStorage.removeItem('postEditorDraft');
  };

  // 组件挂载时加载草稿
  useEffect(() => {
    const savedContent = loadDraftFromLocalStorage();
    setInitialContent(savedContent);
    setEditorInitialized(true);
  }, []);

  // 设置定时器，每1秒自动保存草稿
  useEffect(() => {
    const intervalId = setInterval(() => {
      saveDraftToLocalStorage();
    }, 1000); 
    // 清理定时器
    return () => clearInterval(intervalId);
  }, [selectedValues, selectedUsers, editorData]); 

  // 处理编辑器变化时的回调函数
  const handleEditorChange = useCallback((delta, oldDelta, source, quillInstance) => {
    if (source === 'user' && quillInstance) {
      const data = quillInstance.root.innerHTML;
      setEditorData(data);
      form.setFieldsValue({ content: data });
      console.log("Editor data updated:", data);
    }
  }, [form]);

  // 当selectedValues变化时，更新表单中的selectedValuesall字段
  useEffect(() => {
    const flattenedValues = Object.values(selectedValues).flat();
    form.setFieldsValue({ selectedValuesall: flattenedValues });
  }, [selectedValues, form]);

  // 当selectedUsers变化时，更新表单中的selectedUsers字段
  useEffect(() => {
    form.setFieldsValue({ selectedUsers: selectedUsers });
  }, [selectedUsers, form]);

  // 处理表单提交
  const onFormFinish = async (values) => {
    const result = await handleFinish(values, selectedChats, form);
    if (result?.success && result?.resetChats) {
      setSelectedChats(CHATDATA);
      // 发布成功后清除草稿
      clearDraftFromLocalStorage();
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };

  return (
    <Card bordered={true}>
      <SelectValueUsers
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        selectedUsers={selectedUsers}
        setSelectedUsers={setSelectedUsers}
        userOptions={userOptions}
      />
      <Form
        form={form}
        layout="vertical"
        onFinish={onFormFinish}
        initialValues={{ syncToChat: true }}
      >
        {/* Value之星员工搜索区域 */}
        <Card size="small" style={{ marginBottom: 16 }}>
          <Space direction="vertical" style={{ width: '100%' }}>
            <Space>
              <span style={{ fontSize: '12px' }}>我想点赞他（他们）:</span>
              {/* <Dropdown 
                menu={menuProps} 
                open={dropdownOpen}
                onOpenChange={handleDropdownVisibleChange}
              >
                <Input
                  placeholder="输入Ta姓名"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onPressEnter={(e) => {
                    e.preventDefault();
                    handleSearchUsers();
                  }}
                  onClick={handleInputClick}
                  style={{ width: 140 }}
                  prefix={<SearchOutlined />}
                />
              </Dropdown>
              <Button 
                type="primary" 
                icon={<SearchOutlined />}
                loading={searchingUsers}
                onClick={handleSearchUsers}
                style={{ width: 70 }}
              >
                搜索
              </Button> */}
              <Button type="primary" onClick={showModal}>
                选择
              </Button>
            </Space>
            
            {/* 已选择的用户 */}
            {selectedUsers.length > 0 && (
              <div>
                <div style={{ marginBottom: 8, fontWeight: 'bold' }}>已选择的用户:</div>
                <List
                  size="small"
                  dataSource={selectedUsers}
                  renderItem={(user) => (
                    <List.Item
                      // actions={[
                      //   <Button
                      //     type="text" 
                      //     danger 
                      //     size="small" 
                      //     icon={<DeleteOutlined />}
                      //     onClick={() => handleRemoveUser(user.id)}
                      //   />
                      // ]}
                    >
                      <List.Item.Meta
                        avatar={<Avatar size="small" src={user.avatar} icon={<UserOutlined />} />}
                        title={user.name}
                        // description={
                        //   <Space>
                        //     {user.title && <Tag color="orange">职位: {user.title}</Tag>}
                        //     {user.dept && <Tag color="green">部门: {user.dept}</Tag>}
                        //   </Space>
                        // }
                      />
                    </List.Item>
                  )}
                />
              </div>
            )}
          </Space>
        </Card>
        {/* 隐藏的表单项用于存储selectedValues */}
        <Form.Item name="selectedValuesall" hidden>
          <Input />
        </Form.Item>
        
        {/* 隐藏的表单项用于存储selectedUsers */}
        <Form.Item name="selectedUsers" hidden>
          <Input />
        </Form.Item>
        <Form.Item
          name="title"
          label="标题："
          rules={[{ required: true, message: '请输入标题' }]}
        >
          <Input placeholder="输入标题..." maxLength={50} />
        </Form.Item>
        <p style={{ color: '#999', fontSize: '12px' }}>如：为 Jack Liu 点赞 ——21 人美团的 “中国文化摆渡人”</p>

        <Form.Item
          name="content"
          label="内容："
          rules={[{ required: true, message: '请输入内容' }]}
        >
          {editorInitialized && (
            <Editor
              ref={quillRef}
              readOnly={false}
              defaultValue={initialContent}
              onTextChange={handleEditorChange}
              userid={userInfo}
            />
          )}
        </Form.Item>
        <Button 
          type="primary" 
          onClick={handleValueButtonClick}
          style={{ marginTop: '10px', marginBottom: '10px' }}
        >
          + value
        </Button>
        <List
          header={<div>value</div>}
          bordered
          dataSource={Object.values(selectedValues).flat()}
          renderItem={item => (
            <List.Item>
              {item}
            </List.Item>
          )}
        />

        {/* Value Drawer组件 */}
        <ValueReuseComponent
          visible={valueDrawerVisible}
          onClose={handleValueDrawerClose}
          title="Value选项"
          checkboxGroups={valueGroups}
          selectedValues={selectedValues} // 多选框选中的值
          onCheckboxChange={handleValueCheckboxChange}
        />
        <Form.Item name="syncToChat">
          <GroupChatSelector
            selectedChats={CHATDATA}
            corpId={corpId}
            loading={submitting}
          />
        </Form.Item>
        {/* <Form.Item name="syncToChat" valuePropName="checked">
          <Checkbox>同步到钉钉群聊</Checkbox>
        </Form.Item>

        <Form.Item
          shouldUpdate={(prevValues, currentValues) => 
            prevValues.syncToChat !== currentValues.syncToChat
          }
        >
          {({ getFieldValue }) =>
            getFieldValue('syncToChat') && (
              <GroupChatSelector
                selectedChats={selectedChats}
                setSelectedChats={setSelectedChats}
                corpId={corpId}
                loading={submitting}
              />
            )
          }
        </Form.Item> */}
        
        <Form.Item>
          <Space>
            <Button 
              type="primary" 
              htmlType="submit" 
              loading={submitting}
              icon={<SendOutlined />}
            >
              发布卡片
            </Button>
            <Button 
              onClick={() => {
                form.resetFields(['title', 'content', 'syncToChat', 'selectedValues', 'selectedUsers']);
                setSelectedChats(CHATDATA);
                resetSearchState();
                setSelectedValues({
                  '团队协作：': [],
                  '诚信负责：': [],
                  '客户满意：': [],
                  '发现创新：': [],
                  '系统思维：': []
                });
                setEditorData('');
                setInitialContent('');
                // 清除本地存储的草稿
                clearDraftFromLocalStorage();
                // 重新初始化编辑器
                if (quillRef.current) {
                  quillRef.current.setContents('');
                }
              }}
            >
              重置
            </Button>
            <Button onClick={saveDraftToLocalStorage}>保存草稿</Button>
          </Space>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default PostEditor;